import { FC, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'

import { navigationLinks } from '@src/constants/navigation'
import { ReactComponent as Arrow } from '@src/assets/arrow.svg'
import { Navigation } from '@src/components/Navigation/Navigation'
import { AppDispatch } from '@src/store/store'
import { setIsOpenNav } from '@src/store/ducks/app/reducer'
import { selectAppIsOpenNav } from '@src/store/ducks/app/selectors'
import style from './PageContainer.module.scss'

export const PageContainer: FC = ({ children }) => {
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()
  const isOpenNav = useSelector(selectAppIsOpenNav)

  const activeNav = useMemo(
    () => navigationLinks.find((item) => location.pathname.indexOf(item.url) !== -1), [location.pathname],
  )
  return (
    <div className={style.main}>
      <div className="container">
        <div className={style.title}>Личный кабинет</div>
        {activeNav && (
          <button type="button" className={style.mobile_nav} onClick={() => dispatch(setIsOpenNav(true))}>
            <activeNav.icon className={style.mobile_nav_icon} />
            {activeNav.name}
            <Arrow className={style.mobile_nav_arrow} />
          </button>
        )}
        <div className={style.box}>
          <div className={cn(style.nav, isOpenNav && style.open)}>
            <Navigation />
          </div>
          <div className={style.content}>
            {activeNav?.name && <h1 className={style.content_title}>{activeNav?.name}</h1>}
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
